import { bindDialog, BindDialogReturn, DialogState, useDialogState } from "../../../hooks/use-dialog-state/UseDialogState";
import { PageConfigurationEditorDialogInitValues, PageConfigurationEditorDialogResult } from "./PageConfigurationEditorDialog";

export type PageConfigurationEditorDialogState = DialogState<PageConfigurationEditorDialogInitValues, PageConfigurationEditorDialogResult>;
export type BindPageConfigurationEditorDialogReturn = BindDialogReturn<PageConfigurationEditorDialogInitValues, PageConfigurationEditorDialogResult>;

export function usePageConfigurationEditorDialogState(): PageConfigurationEditorDialogState {
    return useDialogState();
}

export function bindPageConfigurationEditorDialog(props: PageConfigurationEditorDialogState): BindPageConfigurationEditorDialogReturn {
    return bindDialog(props);
}
